import { forwardRef } from 'react';
import MaterialPaper, { PaperProps } from '@mui/material/Paper';

export const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
    return (
        <MaterialPaper ref={ref} data-testid={'Paper-container'} {...props} />
    );
});

export default Paper;
